import { StaticContent } from 'shared/types';

export const staticContentLocalStorageKey = 'content';

export const staticContentStorage = {
  setContent(content: StaticContent) {
    localStorage.setItem(staticContentLocalStorageKey, JSON.stringify(content));
  },
  getContent(): StaticContent {
    const storageStaticContent = localStorage.getItem(
      staticContentLocalStorageKey
    );

    return JSON.parse(storageStaticContent as string) || null;
  },
  removeContent() {
    localStorage.removeItem(staticContentLocalStorageKey);
  },
};
